<div class="speakerslist">
  @for (spk of this.speakersList; track spk) {
<div>
    @if (this.planningEventsLoaded && !spk.generique) {
<app-speaker-list-item
     
      [selected]="this.selected === spk.id"
      [name]="spk.prenom + ' ' + spk.nom"
      [speaker]="spk"
      [status]="this.getStatus(spk)"
      (selectEvent)="this.onSelect(spk)"
    />
}
  </div>
}
</div>
